module.exports = __webpack_public_path__ + "static/media/logo.539ef9c6.svg";